/*
 * File: cell-promo-code-name.ts
 * Created: 2026-01-19 20:10:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellPromoCodeName extends BaseTableBodyCell {
    get noteText() {
        return this.row?.note ? String(this.row.note) : "-";
    }
}
